import { Component, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Tooltip } from 'react-tooltip';

import { OpenModal, RootState } from 'types';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import Button from './Button';
import Icon from './Icon';

interface TabsLayoutProps {
    openModelFunction: OpenModal;
    onTabChange?: (tab: string, nextTab: string) => boolean;
    model: string;
    title?: string;
    language: string;
    activeTab: string;
    full?: boolean;
    tabs: { [key: string]: ReactNode | any };
    withButton?: boolean;
    actions: any;
}

interface TabsLayoutState {
    language: string;
    tabs: string[];
    activeTab: string;
    saving: boolean;
}
// THIS Component is for handling the tabs
class TabsLayout extends Component<TabsLayoutProps, TabsLayoutState> {
    constructor(props: TabsLayoutProps) {
        super(props);
        this.state = {
            activeTab: '',
            tabs: [],
            language: 'en',
            saving: false,
        };
    }

    static getDerivedStateFromProps(props: TabsLayoutProps, state: TabsLayoutState) {
        if (
            props.activeTab !== state.activeTab ||
            props.language !== state.language ||
            checkDifferent(props.tabs, state.tabs)
        ) {
            return {
                tabs: Object.keys(props.tabs),
                language: props.language,
                activeTab: props.activeTab,
            };
        }
        return null;
    }

    toggleActiveTab = (tab: string) => {
        if (this.state.activeTab === tab) {
            return false;
        }
        if (this.props.onTabChange) {
            const isValid = this.props.onTabChange(this.state.activeTab, tab);
            if (!isValid) {
                return false;
            }
        }
    };

    handleFormCancel = () => {
        this.props.actions.onCancel();
    };

    handleFormSubmit = () => {
        this.setState(
            {
                saving: true,
            },
            this.props.actions.onConfirm
        );
    };

    render() {
        const { withButton = true } = this.props;
        return (
            <div className="p-4  bg-white rounded-md w-auto ">
                <Tooltip variant="dark" id="infoTooltip" />
                {this.props.title && (
                    <div className="flex justify-between mb-5  ">
                        <div className="text-lg font-bold capitalize">{translate(this.props.title)}</div>
                        <div className="cursor-pointer">
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                )}

                <div className="flex   gap-2 mb-2 no-select relative border-b border-gray-300">
                    {this.state.tabs.map((tab, index) => {
                        return (
                            <div
                                onClick={() => this.toggleActiveTab(tab)}
                                key={index}
                                className={twclsx(
                                    'font-bold',
                                    'justify-center',
                                    'py-2',
                                    'flex-1',
                                    'capitalize',
                                    'flex',
                                    'cursor-pointer',
                                    'pb-2',
                                    'gap-x-2',
                                    'relative',
                                    'z-10',
                                    'px-2',
                                    (this.state.activeTab !== '' ? this.state.activeTab === tab : index === 0)
                                        ? 'text-blue-500'
                                        : 'text-neutral-400',
                                    index === 0 && 'border-r-2 border-gray-300'
                                )}
                            >
                                <div> {translate(tab)} </div>
                            </div>
                        );
                    })}
                </div>
                {Object.keys(this.props.tabs)
                    .filter((key, index) => {
                        if (this.state.activeTab !== '') {
                            return key === this.state.activeTab;
                        } else {
                            return index === 0;
                        }
                    })
                    .map((key) => {
                        if (this.props.tabs[key]?.com) {
                            return this.props.tabs[key]?.com;
                        }
                        return this.props.tabs[key];
                    })}
                {withButton && (
                    <div className="flex justify-end items-center">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-1 border border-gray-400 font-bold"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.props.actions.onClear}
                            >
                                {translate('Reset')}
                            </Button>
                            <Button
                                loading={this.state.saving}
                                type="submit"
                                onClick={this.handleFormSubmit}
                                className="px-4 py-2 bg-primary-submit rounded-md text-white"
                            >
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const tabsLayoutStateToProps = (state: RootState) => ({
    openModelFunction: state.layout.openModelFunction,
    language: state.user.user.language,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const tabsLayoutDispatchToProps = () => ({});

export default connect(tabsLayoutStateToProps, tabsLayoutDispatchToProps)(TabsLayout);
